import { Typography } from '@mui/material'

type CSVPreviewProps = {
  rows: string[][]
  columns: string[]
}

export const CSVPreview = ({ rows, columns }: CSVPreviewProps) => {
  return (
    <div className='w-full border-1 border-gray-200 rounded-lg overflow-hidden'>
      {/* Header Row */}
      <div
        className='grid bg-[#f5f5f5] border-b-1 border-gray-200'
        style={{
          gridTemplateColumns: `repeat(${columns.length}, minmax(120px, 1fr))`
        }}
      >
        {columns.map((column, index) => (
          <div key={`header-${index}`} className='px-2 p-2 border-r-1 last:border-0 border-gray-200'>
            <Typography
              variant='body2'
              sx={{
                color: '#949494',
                fontWeight: 500,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'wrap'
              }}
            >
              {column}
            </Typography>
          </div>
        ))}
      </div>

      {/* Data Rows */}
      <div className='bg-white'>
        {rows.map((row, rowIndex) => (
          <div
            key={`row-${rowIndex}`}
            className='grid border-b-1 border-gray-200 last:border-b-0'
            style={{
              gridTemplateColumns: `repeat(${columns.length}, minmax(120px, 1fr))`
            }}
          >
            {row.map((cell, cellIndex) => (
              <div key={`cell-${rowIndex}-${cellIndex}`} className='px-2 py-2 border-r-1 last:border-0 border-gray-200'>
                <Typography
                  variant='body2'
                  sx={{
                    color: 'text.primary',
                    fontSize: '14px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {cell || '-'}
                </Typography>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
